import { FC, useRef } from "react";
import styled from 'styled-components/macro';
import useDropdown from "../../../hooks/useDropdown";
import info from '../../../assets/icons/info-circle-solid.svg';


interface TooltipProps {
    optionDescription?: string;
    isMobile?: boolean;
}


const TooltipContainer = styled.div`
    position: absolute;
    left: 42px;
    top: 10px;
    z-index: 3;
    text-align: center;
`;

const InfoIcon = styled.img<{ isMobile?: boolean }>`
    position: absolute;
    left: ${props => props.isMobile ? '40px' : '30px'};
    top: 0px;
    height: 25px;
    width: 25px;
`;

const OptionDescription = styled.div`
    max-width: 120px;
    padding: 5px;
`;

const Tooltip: FC<TooltipProps> = ({ optionDescription, isMobile }) => {
    const [open, close, isOpened, Dropdown] = useDropdown();
    const ref = useRef<HTMLImageElement>(null);

    return <TooltipContainer>
        {isMobile
            ? <InfoIcon
                ref={ref}
                isMobile={isMobile}
                onClick={() => open(ref.current!, 'top', 'left', true)}
                src={info} />
            : <InfoIcon
                ref={ref}
                isMobile={isMobile}
                onMouseEnter={() => open(ref.current!, 'top', 'left', true)}
                onMouseLeave={() => close()}
                src={info} />}
        {isOpened && <Dropdown>
            <OptionDescription>{optionDescription}</OptionDescription>
        </Dropdown>}
    </TooltipContainer>;
}

export default Tooltip;